<template>
  <v-bottom-sheet
    :value="value"
    :persistent="persistent"
    :data-qa="dataQa"
    content-class="VcBottomSheet"
    @input="(val) => $emit('input', val)">
    <template #activator="activatorObj">
      <slot v-bind="activatorObj" name="activator" />
    </template>
    <v-sheet :data-qa="`${dataQa}-sheet`" class="vc-sheet">
      <slot />
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'VcBottomSheet',
  props: {
    /**
     * Opens and closes the bottom sheet display
     */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * If true, the Bottom sheet won't close on "click outside"
     */
    persistent: {
      type: Boolean,
      default: false,
    },
    dataQa: {
      type: String,
      default: 'vc-bottom-sheet',
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../styles/variables.scss';

.VcBottomSheet {
  .vc-sheet {
    max-height: 92vh;
    border-radius: var(--modal-border-radius) var(--modal-border-radius) 0 0;
    display: flex;
    box-shadow: var(--modal-box-shadow);
    overflow: auto;
  }
}
</style>
